import React from 'react';
import { Reveal } from './Reveal';
import { materialPreviews } from '../data/materialPreviews';
export function MaterialPreviewSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-118" data-mp="14vnqzcgc3sgc">
      <Reveal className="mx-auto max-w-6xl" data-id="element-119" data-mp="1jjsf4vy5ow6i">
        <div className="mb-10 text-center" data-id="element-120" data-mp="1jkto8uvm38ll">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-121" data-mp="1erqtijf3lt3t">PAGINE REALI DAL PACCHETTO</p>
          <h2 className="text-3xl font-black text-brand-blue md:text-4xl" data-id="element-122" data-mp="1si41umvwj9to">Uno sguardo dentro il materiale</h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-123" data-mp="1ohaebumdfx1b">
            Teoria illustrata, esercizi graduati e attività già impaginate: queste sono pagine vere, prese dai volumi
            che riceverai.
          </p>
        </div>

        <ul className="-mx-4 flex snap-x snap-mandatory gap-5 overflow-x-auto px-4 pb-4 [scrollbar-width:thin]" data-id="element-124" data-mp="82sftgde5h2z">
          {materialPreviews.map(({
          image,
          title,
          caption,
          tag
        }) => <li key={title} className="flex w-[240px] shrink-0 snap-start flex-col overflow-hidden rounded-2xl border border-brand-dark bg-brand-alt shadow-sm sm:w-[260px]" data-id="element-125" data-mp="2hxz4ndzkbawo">
              <div className="flex h-[340px] items-center justify-center overflow-hidden bg-white p-3 sm:h-[380px]" data-id="element-126" data-mp="2qx2qgpq464ev">
                <img src={image} alt={`Pagina di esempio: ${title}`} loading="lazy" className="h-full w-full object-contain" data-id="element-127" data-mp="2vqf301hiqkr9" />
              </div>
              <div className="flex flex-1 flex-col border-t border-brand-dark px-5 py-4" data-id="element-128" data-mp="35ouvo8w7222v">
                <span className="text-[9px] font-extrabold tracking-[0.14em] text-brand-teal" data-id="element-129" data-mp="3ak0hz8tidirh">{tag}</span>
                <h3 className="mt-1.5 text-base font-bold leading-snug text-brand-blue" data-id="element-130" data-mp="3eldkpa1b15u6">{title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-brand-gray" data-id="element-131" data-mp="1gagafykdwxc4">{caption}</p>
              </div>
            </li>)}
        </ul>

        <p className="mt-6 text-center text-xs font-semibold text-brand-gray" data-id="element-132" data-mp="2nlnu1h1gq1pw">
          Scorri per vedere altre pagine · Tutti i file sono in PDF A4 a 300 DPI, pronti da stampare
        </p>
      </Reveal>
    </section>;
}